import { useMutation, useQueryClient } from "@tanstack/react-query"
import { profile } from "@shared/api/services"
import { toast } from "react-toastify"

export const useRemoveVideoPresentation = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: () => profile.removeVideoPresentation(),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
			toast.success('Видео удалено')
    },
		retry: 0
  })

	return mutation
}